export default __webpack_public_path__ + "static/media/elon.9353c295.jpg";